import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { push as pushToHistory } from 'redux-first-history';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { configs } from '../../../constants/configs/configs';

// Components
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import ManageWorkgroup from './ManageWorkgroup';
import ManageTags from './ManageTags';

// Action creators
import { assigneesActionCreators } from '../../../actions/ticketMgmtPortal/ticketMgmtPortalActionCreators';

// type
import {
    IManageWorkgroupData,
    IManageWorkgroupTagContainer,
} from './manageWorkgroup.interface';
import { DEFAULT_WORKGROUP } from './manageWorkgroupTags.constant';

const ManageWorkgroupTagContainer = (props: IManageWorkgroupTagContainer) => {
    const [workgroupData, setWorkgroupData] =
        useState<IManageWorkgroupData>(DEFAULT_WORKGROUP);
    const [tagList, setTagList] = useState([]);
    const [isUpdateEvent, setUpdateEvent] = useState(false);
    const { id } = useParams();
    const { getWorkgroupsTagsById, getAllTags } = props;

    useEffect(() => {
        if (id) {
            getWorkgroupTagsDetails();
            getEditTagList();
        }
    }, [id]);

    useEffect(() => {
        if (isUpdateEvent) {
            setUpdateEvent(false);
            getWorkgroupTagsDetails();
        }
    }, [isUpdateEvent]);

    const handleBackClick = () => {
        window.location.href = new URL(
            configs.routes.TICKET_MGMT_MANAGE_WORKGROUP,
            window.location.origin,
        ).toString();
    };

    const getWorkgroupTagsDetails = async () => {
        const response = await getWorkgroupsTagsById(id);
        if (response) {
            setWorkgroupData(response);
        }
    };

    const getEditTagList = async () => {
        const response = await getAllTags();
        setTagList(response ?? []);
    };

    return (
        <div className="assignee-section gi-panel" data-testid="manage-tags-edit-main-container">
            <span className="usa-width-one-whole back-to-dashboard" data-testid="manage-tags-edit-main-container-icon">
                <a
                    className="usa-width-one-whole border-link cursor-pointer"
                    href={undefined}
                    onClick={handleBackClick}
                >
                    <FontAwesomeIcon
                        icon="caret-left"
                        size="1x"
                        className="icon-link"
                    />
                    <FormattedMessage id="assignees.link.back_to_results" />
                </a>
            </span>

            <ConditionalRendering
                isTrue={Object.keys(workgroupData)?.length > 0}
            >
                <ManageWorkgroup
                    item={workgroupData}
                    setUpdateEvent={setUpdateEvent}
                />
                <hr />
                <ManageTags
                    items={workgroupData.tags}
                    setUpdateEvent={setUpdateEvent}
                    tagList={tagList}
                />
            </ConditionalRendering>
        </div>
    );
};

export default connect(null, {
    ...assigneesActionCreators,
    pushToHistory,
})(ManageWorkgroupTagContainer);